<template>
  <material-card
    :title="$t('components.plancreationwizard.plan_information')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="info"
  >
    <v-card-text>
      <v-form :disabled="disabled" v-model="valid">
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <tooltip-textbox
              :value.sync="generalSettings.UniqueIdentifier"
              :label="$t('components.plancreationwizard.unique_identifier')"
              :rules="[
                $rules.required,
                $rules.numeric,
                $rules.dynamic.length(3),
                rules.unique,
              ]"
              class="required"
              :tooltipText="
                $t('components.plancreationwizard.unique_identifier_tooltip')
              "
            ></tooltip-textbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <trans-textbox
              v-model="generalSettings.PlanSettings"
              :label="$t('globals.name')"
              :rules="[$rules.required]"
              class="required"
              field="Name"
            ></trans-textbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <pbas-date-picker
                        :value="generalSettings.PlanEffectiveDate"
                        @update-date="
                          generalSettings.PlanEffectiveDate = $event
                        "
                        :label="
                          $t('views.plangeneralparameters.plan_effective_date')
                        "
                        :rules="[$rules.required]"
                        class="required"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col style="margin-top:20px;margin-left:3px" cols="auto">
                      <v-icon v-bind="attrs" v-on="on">
                        help
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("components.plancreationwizard.date_tooltip") }}
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <pbas-date-picker
                        :value="generalSettings.PlanSettings.EffectiveDate"
                        @update-date="changeEffectiveDate"
                        :label="
                          $t('components.plancreationwizard.effective_date')
                        "
                        :rules="[$rules.required, rules.planEffectiveDate]"
                        class="required"
                        :allowedDates="allowedDates"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col style="margin-top:20px;margin-left:3px" cols="auto">
                      <v-icon v-bind="attrs" v-on="on">
                        help
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("components.plancreationwizard.effective_date_tooltip") }}
              </span>
            </v-tooltip>
          </v-col>
        </v-layout>
        <v-layout row wrap>
          <v-col cols="12" md="6" class="pt-0 pb-0">
            <trans-textarea
              v-model="generalSettings.PlanSettings"
              :label="$t('globals.description')"
              field="Description"
            ></trans-textarea>
          </v-col>
          <v-col cols="12" md="6" class="pt-0 pb-0">
            <v-layout row wrap>
              <v-col cols="12" md="6" class="pt-0 pb-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters class="test">
                        <v-col cols="auto">
                          <v-checkbox
                            :class="$attrs['class']"
                            v-model="registered"
                            :label="
                              $t(
                                'components.plan_builder.pensionsplanbuilder.registered'
                              )
                            "
                          ></v-checkbox>
                        </v-col>
                        <v-col
                          style="margin-top: 20px; margin-left: 3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{
                      $t(
                        "components.plan_builder.pensionsplanbuilder.registered_tooltip"
                      )
                    }}
                  </span>
                </v-tooltip>
              </v-col>
              <template v-if="registered">
                <v-col cols="12" md="6" class="pt-0 pb-0">
                  <trans-select
                    :item="generalSettings"
                    propertyName="ProvinceOfRegistration"
                    :items="options.Models.Province"
                    :label="
                      $t(
                        'components.plan_builder.pensionsplanbuilder.province_of_registration'
                      )
                    "
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-select>
                </v-col>
                <v-col cols="12" md="6" class="pt-0 pb-0">
                  <no-autocomplete-textfield
                    v-model="generalSettings.ProvincialRegNo"
                    :label="
                      $t(
                        'components.plan_builder.pensionsplanbuilder.provincial_registration_number'
                      )
                    "
                    :clearable="true"
                    :rules="[$rules.alphanumeric, $rules.dynamic.length(6)]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col cols="12" md="6" class="pt-0 pb-0">
                  <no-autocomplete-textfield
                    v-model="generalSettings.CRARegNo"
                    :label="
                      $t(
                        'components.plan_builder.pensionsplanbuilder.cra_registration_number'
                      )
                    "
                    :clearable="true"
                    :rules="[$rules.required, $rules.numeric, $rules.dynamic.length(7)]"
                    class="required"
                  ></no-autocomplete-textfield>
                </v-col>
              </template>
            </v-layout>
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
import TooltipTextbox from "@/components/TooltipTextbox";
import TransTextarea from "@/components/TransTextarea";
import TransTextbox from "@/components/TransTextbox";
import { mapActions, mapGetters } from "vuex";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import TransSelect from "@/components/TransSelect.vue";

export default {
  props: ["generalSettings", "disabled", "uniqueIdentifiers"],
  components: {
    TooltipTextbox,
    TransTextarea,
    TransTextbox,
    NoAutocompleteTextfield,
    TransSelect,
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  data() {
    return {
      rules: {
        planEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.generalSettings === null ||
            this.generalSettings === undefined ||
            this.generalSettings.PlanEffectiveDate === null ||
            this.generalSettings.PlanEffectiveDate === undefined
          ) {
            return true;
          }

          const n = Date.parse(this.generalSettings.PlanEffectiveDate);
          const d = new Date(n);

          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [this.formatDate(d)]);
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d || this.$t("validation.date_{0}", [this.formatDate(d)])
          );
        },
        unique: (v) =>
          this.uniqueIdentifiers.indexOf(v) === -1 ||
          this.$t("validation.unique_plan"),
      },
      registered: false,
      valid: false,
      uniqueIdentifier: undefined,
      uniqueIdentifierMonitor: null,
    };
  },
  watch: {
    registered: {
      handler(v) {
        if (!v) {
          this.generalSettings.ProvinceOfRegistration = undefined;
          this.generalSettings.ProvincialRegNo = undefined;
          this.generalSettings.CRARegNo = undefined;
        }
      },
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
    "generalSettings.UniqueIdentifier": {
      async handler(v) {
        if (v === null) {
          return;
        }
        const obj = {};
        this.uniqueIdentifierMonitor = obj;
        await this.delay(800);
        if (this.uniqueIdentifierMonitor !== obj) {
          return;
        }
        this.$emit("load-unique-identifiers");
      },
    },
  },
  async mounted() {
    if (
      this.generalSettings.ProvinceOfRegistration !== null &&
      this.generalSettings.ProvinceOfRegistration !== undefined
    ) {
      this.registered = true;
    }
  },
  methods: {
    changeEffectiveDate(val) {
      // generalSettings.PlanSettings.EffectiveDate=$event
      this.generalSettings.PlanSettings.EffectiveDate = val;
    },
    allowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.generalSettings.PlanEffectiveDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    isValidSystemEffectiveDate(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.generalSettings.PlanEffectiveDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    formatDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>
